import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./index.css";

import App from "./App";
import GroupCover from "./components/GroupCover";
import NotFound from "./components/NotFound";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import { AuthProvider, useAuth } from "./dashboard/AuthContext";
import Login from "./dashboard/Login";
import Signup from "./dashboard/Signup";
import Dashboard from "./dashboard/Dashboard";

/* ─── Route guard for /dashboard ──────────────────────── */
function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null; // dashboard's own loader will paint after auth resolves
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}

/* ─── Top-level route table ───────────────────────────── */
function Root() {
  return (
    <Routes>
      {/* Group gateway — animated wordmark, then the project carousel */}
      <Route path="/" element={<GroupCover />} />
      {/* Marketing site — the existing single-page App, now at /home */}
      <Route path="/home" element={<App />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/login"  element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Root />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
